import { Reveal } from "@/components/Reveal";
import { SERVICES } from "@/data/site";
import { Check } from "lucide-react";

export function Services() {
  return (
    <section id="services" className="relative py-24 lg:py-32" data-testid="services">
      <div className="mx-auto max-w-7xl px-5 lg:px-8">
        <Reveal>
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-magenta">What we do</p>
          <h2 className="max-w-3xl font-display text-4xl font-extrabold leading-none tracking-tight sm:text-5xl lg:text-6xl">
            One team for the whole Amazon growth engine.
          </h2>
        </Reveal>

        <div className="mt-16 space-y-4">
          {SERVICES.map((s, i) => (
            <Reveal key={s.no} delay={i * 0.08}>
              <div className="group grid grid-cols-1 gap-6 rounded-2xl border border-white/8 bg-surface/40 p-8 transition-colors hover:border-orange/30 lg:grid-cols-12 lg:p-10" data-testid={`service-${s.no}`}>
                <div className="lg:col-span-3">
                  <span className="text-stroke font-display text-7xl font-black lg:text-8xl">{s.no}</span>
                </div>
                <div className="lg:col-span-5">
                  <h3 className="font-display text-2xl font-bold lg:text-3xl">{s.title}</h3>
                  <p className="mt-4 text-base font-light leading-relaxed text-muted">{s.desc}</p>
                </div>
                <div className="lg:col-span-4">
                  <ul className="space-y-3">
                    {s.points.map((p) => (
                      <li key={p} className="flex items-center gap-3 text-sm text-white/80">
                        <Check className="h-4 w-4 shrink-0 text-orange" /> {p}
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
